
import sanitizeHtml from 'sanitize-html';
import { Component, Vue } from 'nuxt-property-decorator';
import FourwavesLogoFull from 'fourwaves-shared/src/images/fourwaves-light-full.png';
import LangChooser from '~/components/navigation/LangChooser.vue';
import SignInCta from '~/components/account/SignInCta.vue';
import GradientAnimation from '~/components/account/GradientAnimation.vue';

@Component({
  components: {
    LangChooser,
    SignInCta,
    GradientAnimation,
  },
})
export default class SignInLayout extends Vue {
  readonly FourwavesLogoFull = FourwavesLogoFull;

  mounted() {
    if (this.$route && this.$route.query && this.$route.query.tmsg) {
      const message = sanitizeHtml(this.$t(this.$route.query.tmsg as string));
      this.$toast.success(message);

      if (!this.$route.query.redirect) {
        const query = Object.assign({}, this.$route.query);
        delete query.tmsg;
        this.$router.replace({ query });
      }
    }

    this.$moment.locale(this.$i18n.locale);
  }
}
